module.exports = __webpack_public_path__ + "img/categorie-commentcamarche-famille-boutrais-small.114891a5.jpg";